import { render, staticRenderFns } from "./WorkflowGraph.vue?vue&type=template&id=5df0c685"
import script from "./WorkflowGraph.vue?vue&type=script&lang=js"
export * from "./WorkflowGraph.vue?vue&type=script&lang=js"
import style0 from "./WorkflowGraph.vue?vue&type=style&index=0&id=5df0c685&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports